import './App.css';
import { Route, Routes } from 'react-router-dom';
import Navbar from './Components/Navbar';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import ProcessDesign from './Components/ProcessDesign'
import Home from './Components/Home'
import Footer from './Components/Footer';
import { MsalAuthenticationTemplate } from '@azure/msal-react';
import { InteractionType } from '@azure/msal-browser';
function App() {
  const authRequest = {
    scopes: ["user.read"],
    login_hint: localStorage.getItem('userName')
  };
  return (
    <div className="App">
      <MsalAuthenticationTemplate interactionType={InteractionType.Redirect} authenticationRequest={authRequest} >
        <div className="d-flex justify-content-center" style={{ fontSize: "20px", color: "#7500c0" }}>Business Process Management</div>
        <Navbar />
        <Routes>
          <Route path='/' element={<Home />} exact />
          <Route path='/processDesign' element={<ProcessDesign />} exact />
        </Routes>
        <Footer />
      </MsalAuthenticationTemplate>
    </div>
  );
}

export default App;
